import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class Thermistor extends AlertLogic {
    static type = AlertType.ThermistorError;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.SYSTEM_ERROR ];
    static title = Locale.gettext('Thermistor Issue');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Varying across alert types
        const port = device.HardwareDevice ? this.locale.gettext('(%1$s port: %2$s)',
            Config.getPortTypeLocalised(device.HardwareDevice?.Ports[0]?.Type),
            device.HardwareDevice?.Ports[0]?.Number
        ) : '';
        let cardDescription = '';
        let detailDescription = '';
        switch (alertData?.ErrorState) {
            case 'TOO_LOW':
                cardDescription = this.locale.gettext('%1$s reading too low', device.Name);
                detailDescription = this.locale.gettext('The temperature sensor "%1$s" %2$s is reading too low %3$s.',
                        device.Name,
                        port,
                        this.locale.formatTemperatureFromFahrenheit(alertData?.TemperatureF));
                break;
            case 'TOO_HIGH':
                cardDescription = this.locale.gettext('%1$s reading too high', device.Name);
                detailDescription = this.locale.gettext('The temperature sensor "%1$s" %2$s is reading too high %3$s.',
                        device.Name,
                        port,
                        this.locale.formatTemperatureFromFahrenheit(alertData?.TemperatureF));
                break;
        }

        let detailDescription2 = '';
        switch (alertData?.ErrorState) {
            case 'TOO_LOW':
                detailDescription2 = this.locale.gettext('This could mean the sensor has failed, it is not plugged in, or the wire is damaged.'); break;
            case 'TOO_HIGH':
                detailDescription2 = this.locale.gettext('This could mean the sensor has failed, the wire has been damaged and it\'s shorted, or the wire has been cut and is in direct sunlight.'); break;
        }

        let detailDescription3 = this.locale.gettext('Contact your pool maintainer or the device manufacturer if the problem continues.');
        
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Temperature Sensor Error'),
            cardIllustration: 'report_frightened',
            cardDescription: cardDescription,
            detailIcon: 'temperature-sensor',
            detailDescription,
            detailDescription2,
            detailDescription3,
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('Temperature sensor error resolved')
        });
        alertInfo.contentCategories = Thermistor.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord|AlertRecord[] {
        const device = config.Config.Devices.find(dev => dev.DeviceType === Config.DeviceTypes.THERMISTOR);
        
        return [
            new AlertRecord({
                id: Math.floor(Math.random() * 100000),
                uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "HIGH" + type),
                siteId: Math.floor(Math.random() * 100000),
                entityUuid: device.UUID,
                bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
                type: type,
                data: {
                    ErrorState: 'TOO_HIGH',
                    TemperatureF: 99
                }
            }),
            new AlertRecord({
                id: Math.floor(Math.random() * 100000),
                uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
                siteId: Math.floor(Math.random() * 100000),
                entityUuid: device.UUID,
                bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
                type: type,
                data: {
                    ErrorState: 'TOO_LOW',
                    TemperatureF: 22
                }
            })
        ];
    }
}